import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import { useState, useEffect, useContext } from 'react';
import {
    TextField,
    Grid2,
} from "@mui/material";
import FormHelperText from '@mui/material/FormHelperText';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { GlobalStyles } from '@mui/material';
import './Login.css';
import { ThemeContext } from '../../DarkMode/ThemeProvider';
import { useDispatch, useSelector } from 'react-redux';
import { removeLoginStatus, updateAuthStatus, updateOtpTime, UserLogin } from '../../../Actions/AuthAction';
import { ToastError, ToastSuccess } from '../../../CustomToaster/CustomToaster';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { resendOtp } from '../../../Services/auth';
import { InputError } from '../../Errors/ErrorText';
import lightLogo from '../../../Images/fouchain-logo-light.svg';
import darkLogo from "../../../Images/fouchain-logo-dark.svg";


const Login = () => {
    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };
    const { isLightMode, handleDarkmode } = useContext(ThemeContext);

    //custom code
    const navigate = useNavigate();
    const location = useLocation();
    const [userDetail, setUserDetail] = useState({
        email: "",
        password: "",
    });

    const [errors, setErrors] = useState({
        email: "",
        password: "",
    });

    const dispatch = useDispatch();

    const { authData, authStatus, authLoading, authError, isAuthenticated } = useSelector((state) => state.auth);

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        const fieldValue = value.trim();

        if (name === "password") {
            if (fieldValue?.length >= 30) {
                e.preventDefault();
                return;
            }
        }

        setUserDetail({ ...userDetail, [name]: value });
    };

    const [load, setLoad] = useState(false);
    const [verify, setVerify] = useState(false);

    const validateFocus = (e = null) => {
        let isValid = true;
        const formErrors = {};

        if (e) {
            const { name, value } = e.target;
            if (name === "email" && value.trim() && !/\S+@\S+\.\S+/.test(value)) {
                formErrors.email = "Email is invalid";
                isValid = false;
            }
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: formErrors[name] || "",
            }));
        } else {
            if (!userDetail.email || !/\S+@\S+\.\S+/.test(userDetail.email)) {
                formErrors.email = "Enter your Email";
                isValid = false;
            }
            if (!userDetail.password) {
                formErrors.password = "Enter your Password";
                isValid = false;
            }
            setErrors(formErrors);
        }

        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateFocus()) {
            setLoad(true);
            setVerify(false);
            const data = {
                logType: "email",
                email: userDetail?.email,
                password: userDetail?.password,
            };
            dispatch(UserLogin(data));
        }
    };

    useEffect(() => {
        if (isAuthenticated) {
            navigate("/");
        }
        dispatch(removeLoginStatus());
    }, []);

    useEffect(() => {
        if (authStatus === true) {
            const response = authData.result;

            dispatch(removeLoginStatus());

            if (response?.details?.accountVerified === true) {
                if (
                    !response?.details?.remainingtime &&
                    response?.isAuthenticated === true
                ) {
                    ToastSuccess({ message: authData.message });
                }

                let navigateTo = "/portfolio"
                if (location?.state?.prevPage) {
                    navigateTo = location.state.prevPage;
                }
                if (response?.details?.twoFactorEnabled === true) {
                    dispatch(
                        updateOtpTime(
                            response?.details?.time || response?.details?.remainingtime
                        )
                    );
                    navigate('/twofactor', {
                        replace: true,
                        state: {
                            method: response?.details?.twoFactorMethod,
                            time: response?.details?.time,
                            email: response?.details?.email,
                            token: response?.accessToken,
                        },
                    });
                } else {
                    navigate(navigateTo, { replace: true });
                    dispatch(updateAuthStatus(response?.accessToken));
                }
            } else {
                if (response?.details?.accountVerified === false) {

                    setVerify(true);
                    ToastError({ message: authError || "Somthing went wrong" });
                } else {
                    ToastError({ message: authError || "Somthing went wrong" });
                }
                setLoad(false);
                dispatch(removeLoginStatus());
            }
        } else if (authStatus === false) {
            const response = authData?.result;
            if (response?.blocked === true) {
                dispatch(updateOtpTime(response?.time));

                navigate("/twofactor", {
                    state: {
                        data: response,
                        time: response?.time,
                        email: response?.email,
                        method: response?.twoFactorMethod,
                    },
                });
            } else {
                ToastError({ message: authData.message || "Somthing went wrong" });
            }

            setLoad(false);
            dispatch(removeLoginStatus());
        }
    }, [authStatus]);

    const handleVerifyEmail = async () => {
        const data = {
            type: "email",
            value: userDetail.email,
            verifyType: "Verify-Login",

            // email: userDetail.email,
        };
        setLoad(true);
        const response = await resendOtp(data);
        if (response?.data?.success === true) {
            setVerify(false);
            ToastSuccess({ message: "OTP send successfull" });

            dispatch(
                updateOtpTime(
                    response?.data?.result?.time || response?.data?.result?.remainingtime
                )
            );

            navigate("/verify", { state: { data: response?.data?.result, type: 'Verify-Login' } });

            setLoad(false);
        } else {
            if (response?.data?.result?.blocked === true) {
                dispatch(updateOtpTime(response?.data?.result?.time));

                navigate("/verify", { state: { data: response?.data?.result } });
            } else {
                ToastError({ message: response?.data?.message || "Somthing went wrong" });
            }
            setLoad(false);
        }
    };


    return (
        <div className='auth-page login-page'>
            <GlobalStyles
                styles={{
                    ':root': {
                        '--Form-maxWidth': '800px',
                        '--Transition-duration': '0.4s',
                    },
                }}
            />
            <Box
                component="main"
                className='login-card'
            >
                <Link to={'/'}>
                    <div className="logo">
                        <img width={120} src={!isLightMode ? lightLogo : darkLogo} alt="logo" />
                    </div>
                </Link>
                <Stack sx={{ gap: 2, mb: 2 }}>

                    <Stack sx={{ gap: 1 }}>
                        <Typography className="gold-color" component="h1" sx={{ fontSize: '35px', textAlign: 'center' }}>
                            Log in
                        </Typography>
                        <Typography level="body-sm" sx={{ fontSize: '16px', textAlign: 'center' }}>
                            Sign in to stay connected.
                        </Typography>
                    </Stack>
                </Stack>

                <Grid2 container>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <FormControl fullWidth required>

                            <div className='input-common mt-20'>
                                <FormLabel>Email Address</FormLabel>
                                <TextField
                                    fullWidth
                                    placeholder='Enter the email'
                                    name="email"
                                    type="email"
                                    inputProps={{ maxLength: 40 }}
                                    value={userDetail.email}
                                    onChange={(e) => handleChange(e)}
                                    onInput={validateFocus}
                                    error={!!errors.email}
                                    variant="outlined" />
                            </div>
                            <InputError error={errors.email} />

                        </FormControl>
                    </Grid2>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <FormControl fullWidth required>
                            <div className='input-common mt-10'>
                                <FormLabel>Password</FormLabel>
                                <OutlinedInput
                                    id="outlined-adornment-password"
                                    type={showPassword ? 'text' : 'password'}
                                    value={userDetail.password}
                                    placeholder="********"
                                    onChange={(e) => {
                                        handleChange(e);
                                    }}
                                    onInput={validateFocus}
                                    name="password"
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label={
                                                    showPassword ? 'hide the password' : 'display the password'
                                                }
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                onMouseUp={handleMouseUpPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />


                            </div>

                            <InputError error={errors.password} />

                        </FormControl>
                        <FormHelperText id="filled-weight-helper-text" sx={{ margin: '0', textAlign: "end", paddingTop: '8px' }}>                    <Box display="flex" alignItems="center">
                            <div className='cta '>
                                {verify === true ? (
                                    <div className='mt-10 cursor' onClick={() => handleVerifyEmail()}>
                                        <span className="gold-color" style={{ textDecoration: 'none', fontSize: '14px', }}> Verify Email</span>
                                    </div>
                                ) : (
                                    <Link to="/forget">
                                        <span className='cta gold-color' style={{ textDecoration: 'none', fontSize: '14px', }}> Forget password ?</span>
                                    </Link>
                                )}
                            </div>
                        </Box></FormHelperText>
                    </Grid2>

                    <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <Stack spacing={2} mt={2}>
                            <div className='but-one text-center mt-20'>
                                {authLoading === true ?
                                    <Button type="submit" variant="contained" fullWidth disabled>
                                        Progressing
                                    </Button>
                                    :
                                    <Button type="submit" variant="contained" fullWidth onClick={(e) => handleSubmit(e)}>
                                        Sign in
                                    </Button>}

                            </div>
                        </Stack>
                    </Grid2>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <Typography level="body-sm" sx={{ textAlign: 'center' }} className='mt-20'>
                            Don’t have an account? <span className='cta'><Link to="/register" className='hover-underline-animation gold-color' level="title-sm" sx={{ textDecoration: 'none', paddingLeft: '5px', color: '#3665FF', fontSize: '14px' }}> Click here to sign up.</Link></span>
                        </Typography>
                    </Grid2>
                </Grid2>
            </Box>
        </div>
    )
}

export default Login
